/*=============================================================================
 apiCommon.ts - Common definitions for API data

 - Backend API dependent namings

 (C) 2021 SpacetimeQ INC
=============================================================================*/
import firebase from './firebase';

/**
 * Firebase Auth Error
 */
export type TAuthError  = firebase.auth.Error;
/**
 * { seconds: number; nanoseconds: number; }
 */
export type TTimestamp = firebase.firestore.Timestamp;

// ----------------------------------------------------------------------------
// Collections and Documents, structural definitions
// Firebase Cloud Firestore
// - User UID: 28 digits  4V9x6bgXA8Pb4bE80RqJ2lsKDIe2
// - doc id:   20 digits  HgOCHACGcol4jj3gxoLW
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// constants for *Slice reducers; use constants for consistency
// ----------------------------------------------------------------------------
export const AUTH  = 'auth';
export const USERS = 'users';
export const CONTS = 'conts';  // Contacts
export const ROOMS = 'rooms';
export const MSGS  = 'msgs';   // messages

export const fsPath = {  // Firestore Path to collections and documents
  users: USERS,  // collection
  rooms: ROOMS,  // collection
  user:  (uid:    TUserID) => `${USERS}/${uid}`,             // doc
  room:  (roomId: TRoomID) => `${ROOMS}/${roomId}`,          // doc
  conts: (uid:    TUserID) => `${USERS}/${uid}/${CONTS}`,    // sub-collection
  msgs:  (roomId: TRoomID) => `${ROOMS}/${roomId}/${MSGS}`,  // sub-collection
  cont:  (uid:    TUserID, cid:   TUserID) => `${USERS}/${uid}/${CONTS}/${cid}`,      // doc
  msg:   (roomId: TRoomID, msgId: TMsgID)  => `${ROOMS}/${roomId}/${MSGS}/${msgId}`,  // doc
}
// ----------------------------------------------------------------------------

type TTimestampProp = 'createdAt'|'signInAt'|'time';

/**
 * convert firebase timestamp to a serializable miliseconds (number)
 */
export const serializeTime = (ts: TTimestamp) => (ts.seconds * 1000);

/**
 * serialize Timestamp and construct an object with the given property name
 * index signature to give the shape of data object
 */
// export const serializeTS = (prop: TTimestampProp, ts: Undefinable<TTimestamp>) =>
//   ts && ({ [prop]: serializeTime(ts) });

/**
 * let the firebase get server Timestamp and construct an object with prop
 */
export const serverTS = (prop: TTimestampProp) =>
  ({ [prop]: firebase.firestore.FieldValue.serverTimestamp() });
